export const PRICE_FREE = "PRICE_FREE";

export const PRODUCT_TYPES = {
  DONATION: "DONATION",
  FEE: "FEE",
  MENU: "MENU",
  PACK: "PACK",
  REFUNDABLE: "REFUNDABLE",
  REFUNDABLE_LEGACY_ZONE: "REFUNDABLE_LEGACY_ZONE",
  REFUNDABLE_RETURN: "REFUNDABLE_RETURN",
  REFUNDABLE_RETURN_LEGACY_ZONE: "REFUNDABLE_RETURN_LEGACY_ZONE",
  STANDARD: "STANDARD",
  TIP: "TIP",
  VARIANT: "VARIANT",
  VIRTUAL: "VIRTUAL",
  VARIANT_BASE: "VARIANT_BASE",
  PACK_ADVANCED: "PACK_ADVANCED",
  STOCK: "STOCK",
  STOCK_VESSEL: "STOCK_VESSEL",
};
